import PictureData from "../../../../data/HomePictureData"
import "../../css/marquee.css"

const Pictures = () => {
    return (
        <section className="container pictures__container">
            {
                PictureData.length > 0 &&
                <div className="container">
                    <section className="animated__marquee">
                        <h1 className="text-cursive title-center">we're getting married!</h1>
                        <h1 className="text-cursive title-center__backdrop">we're getting married!</h1>
                        <div className="marquee">
                            <ul className="marquee__content">
                                {
                                    PictureData.map(pic => (
                                        <div key={pic.id} className="marquee__content-item">
                                            <img src={pic.image} alt={`marquee1_item${pic.id}`}/>
                                        </div>
                                    ))
                                }
                            </ul>
                            <ul className="marquee__content">
                                {
                                    PictureData.map(pic => (
                                        <div key={pic.id} className="marquee__content-item">
                                            <img src={pic.image} alt={`marquee2_item${pic.id}`}/>
                                        </div>
                                    ))
                                }
                            </ul>
                        </div>
                    </section>
                </div>
            }
        </section>
    );
};

export default Pictures;